import * as Post from '../constants/Post';
import axios from 'axios';

import * as SG from '../constants/AppSettings';
import { loadStart, loadEnd, noticeAdd } from './App';
import { communityGet } from './Community'

// 投稿作成
export function postCreate(params, communityId) {
  return dispatch => {
    dispatch(loadStart());

    axios.post(SG.POST_CREATE_URL, {
      community_id: communityId,
      post: {
        content: params
      }
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    })
      .then(function (r) {
        dispatch(communityGetFromPost(communityId))
        dispatch(loadEnd())
        dispatch(postCreateResult(r.data.post.id))
        dispatch(noticeAdd('サークルに投稿しました', 'success'))

        return {
          type: Post.POST_CREATE
        }
      })
      .catch(function () {
        dispatch(noticeAdd('投稿失敗', 'error'))
        dispatch(loadEnd())
        return {
          type: Post.POST_CREATE
        }
      });

  }
}

export function postCreateResult(createdId) {
  return {
    type: Post.POST_CREATE_RESULT,
    createdId
  }
}

// 投稿UPDATE
export function postUpdate(params, postId, communityId) {
  return dispatch => {
    dispatch(loadStart());
    axios.put(SG.POST_UPDATE_URL.replace(/:id/, postId), {
      post: { content: params }
    }, {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(function (r) {
        dispatch(loadEnd())
        dispatch(postUpdateResult(r.data.post))
        dispatch(communityGet(communityId))
        dispatch(noticeAdd('投稿内容を更新しました', 'success'))

        return {
          type: Post.POST_UPDATE
        }
      })
      .catch(function () {
        dispatch(noticeAdd('投稿更新失敗', 'error'))
        dispatch(loadEnd())
        return {
          type: Post.POST_UPDATE
        }
      });

  }
}

export function postUpdateResult(post) {
  return {
    type: Post.POST_UPDATE_RESULT,
    post
  }
}

export function communityGetFromPost(communityId) {
  return dispatch => {
    dispatch(communityGet(communityId))
  }
}

export function postGetResult(post) {
  return {
    type: Post.POST_INFO_GET_RESULT,
    post
  }
}

export function postInfoRemove() {
  return {
    type: Post.POST_INFO_REMOVE
  }
}

export function postDestroy(postId, communityId) {
  return dispatch => {
    dispatch(loadStart());
    axios.delete(SG.POST_UPDATE_URL.replace(/:id/, postId), {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(function (r) {
        dispatch(loadEnd())
        dispatch(communityGetFromPost(communityId))
        dispatch(postDestroyResult(r.data.post))
        dispatch(noticeAdd(r.data.messages[0], 'error'))
        // console.log('削除',r)
        return {
          type: Post.POST_DESTROY
        }
      })
      .catch(function () {
        dispatch(noticeAdd('投稿削除失敗', 'error'))
        dispatch(loadEnd())
        return {
          type: Post.POST_DESTROY
        }
      });

  }
}

export function postDestroyResult(message) {
  return {
    type: Post.POST_DESTROY_RESULT,
    message
  }
}

export function postDestroyFlagRemove() {
  return {
    type: Post.POST_DESTROY_FLAG_REMOVE
  }
}

export function commentCreate(comment, postId, communityId) {
  return dispatch => {
    dispatch(loadStart())
    axios.post(SG.COMMENT_CREATE_URL, {
      post_id: postId,
      comment: {
        content: comment
      }
    }, {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      }).then(res => {
        dispatch(noticeAdd('コメントを投稿しました', 'success'))
        dispatch(communityGetFromPost(communityId))
        dispatch(commentCreateResult(res))
      }).catch(res => {
        dispatch(noticeAdd('コメント投稿に失敗しました', 'error'))
        dispatch(loadEnd())
      })
  }
}

export function commentCreateResult(res) {
  return {
    type: Post.POST_COMMENT_CREATE_RESULT
  }
}

export function commentUpdate(comment, commentId, communityId) {
  return dispatch => {
    dispatch(loadStart())
    axios.put(SG.COMMENT_UPDATE_URL.replace(/:id/, commentId), {
        comment: {
          content: comment
        }
      }, {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(function (r) {
        dispatch(loadEnd())
        dispatch(commentUpdateResult(r))
        dispatch(communityGetFromPost(communityId))
        dispatch(noticeAdd('コメントを更新しました', 'success'))

        return {
          type: Post.POST_COMMENT_UPDATE
        }
      })
      .catch(function () {
        dispatch(noticeAdd('コメント更新に失敗しました', 'error'))
        dispatch(loadEnd())
        return {
          type: Post.POST_COMMENT_UPDATE
        }
      });
  }
}

export function commentUpdateResult(res) {
  return {
    type: Post.POST_COMMENT_UPDATE_RESULT
  }
}


export function commentDestroy(commentId, communityId) {
  return dispatch => {
    dispatch(loadStart())
    axios.delete(SG.COMMENT_DESTROY_URL.replace(/:id/, commentId), {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(function (r) {
        dispatch(loadEnd())
        dispatch(postDestroyResult(r.data.post))
        dispatch(communityGetFromPost(communityId))
        dispatch(noticeAdd(r.data.messages[0], 'error'))
        // console.log('削除',r)
        return {
          type: Post.POST_DESTROY
        }
      })
      .catch(function () {
        dispatch(noticeAdd('コメント削除に失敗しました', 'error'))
        dispatch(loadEnd())
        return {
          type: Post.POST_DESTROY
        }
      });
  }
}

export function checkMyPost(circle, currentUser) {
  if (!circle && !!circle.host && !!currentUser && circle.host.id === currentUser.id) {
    return true
  } else {
    return false
  }
}




// WEBPACK FOOTER //
// ./src/actions/Post.js